import { BadgeLevel } from '@vizit/atoms';
import { BulkInviteEmailStatus } from './types';

const TEMPLATE_FILE_NAME = 'Vizit_Bulk_Invite_Users.csv';

/** Maps a preview status to the Badge level used to render it. */
export function statusToBadgeLevel(status: BulkInviteEmailStatus): BadgeLevel {
  switch (status) {
    case BulkInviteEmailStatus.Valid:
      return BadgeLevel.Success;
    case BulkInviteEmailStatus.InvalidFormat:
      return BadgeLevel.Error;
    case BulkInviteEmailStatus.Duplicate:
      return BadgeLevel.Warning;
    case BulkInviteEmailStatus.AlreadyActive:
      return BadgeLevel.Information;
    case BulkInviteEmailStatus.Pending:
      return BadgeLevel.Information;
    default:
      // Defensive fallback if the server introduces a new status the FE hasn't mapped yet.
      return BadgeLevel.Default;
  }
}

/** Human-readable label shown inside each status Badge (status conveyed by text, not only color). */
export const STATUS_LABELS: Record<BulkInviteEmailStatus, string> = {
  [BulkInviteEmailStatus.Valid]: 'Ready to invite',
  [BulkInviteEmailStatus.InvalidFormat]: 'Invalid email',
  [BulkInviteEmailStatus.Duplicate]: 'Duplicate',
  [BulkInviteEmailStatus.AlreadyActive]: 'Already active',
  [BulkInviteEmailStatus.Pending]: 'Invite pending',
};

/** The downloadable template body: a single `Email` column with one example row. */
export function buildTemplateContent(): string {
  return 'Email\nuser@example.com\n';
}

/** Trigger a browser download of the CSV template. */
export function downloadTemplate(): void {
  const blob = new Blob([buildTemplateContent()], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = TEMPLATE_FILE_NAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export { TEMPLATE_FILE_NAME };
